var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile",
    clipPath: "url(#clip0_262_4016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1047",
    d: "M0.75 3.07275C0.75 1.83011 1.75736 0.822754 3 0.822754H11C12.2426 0.822754 13.25 1.83011 13.25 3.07275V17.0728C13.25 18.3154 12.2426 19.3228 11 19.3228H3C1.75736 19.3228 0.75 18.3154 0.75 17.0728V3.07275Z",
    fill: "#FFBBBB",
    stroke: "#EEAAAA",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2978 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 17.0728C5.25 16.6585 5.58579 16.3228 6 16.3228H8C8.41421 16.3228 8.75 16.6585 8.75 17.0728C8.75 17.487 8.41421 17.8228 8 17.8228H6C5.58579 17.8228 5.25 17.487 5.25 17.0728Z",
    fill: "#DE8D8D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_262_4016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 20,
    fill: "white",
    transform: "translate(0 0.0727539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.f0bbcad820fb8fcaf6c76f77814cc78c.svg";
export { ForwardRef as ReactComponent };